import { makeStyles } from '@material-ui/core/styles';

export const useControlledCheckboxStyles = makeStyles({
  error: {
    marginTop: 0,
    marginBottom: 5,
  }
});
